import { render } from "./TaxCodeSelect.vue?vue&type=template&id=64da3468"
import script from "./TaxCodeSelect.vue?vue&type=script&lang=js"
export * from "./TaxCodeSelect.vue?vue&type=script&lang=js"

import exportComponent from "/home/ploi/pakair.com.au/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__